// Copyright (c) 2026 Yunus YILDIZ — SPDX-License-Identifier: BUSL-1.1

/** sessionStorage payload between /login → Microsoft → /auth/microsoft/complete */
export const PORTAL_MS_SSO_STORAGE_KEY = 'sdf_portal_ms_sso'

export interface PortalMsSsoPayload {
  flowId: string
  pollToken: string
  startedAt: number
}

export function readPortalMsSsoPayload(): PortalMsSsoPayload | null {
  try {
    const raw = sessionStorage.getItem(PORTAL_MS_SSO_STORAGE_KEY)
    if (!raw) return null
    const data = JSON.parse(raw) as Partial<PortalMsSsoPayload>
    if (
      typeof data.flowId === 'string' &&
      typeof data.pollToken === 'string' &&
      data.flowId.length > 0 &&
      data.pollToken.length >= 8
    ) {
      return {
        flowId: data.flowId,
        pollToken: data.pollToken,
        startedAt: typeof data.startedAt === 'number' ? data.startedAt : Date.now(),
      }
    }
    return null
  } catch {
    return null
  }
}

export function clearPortalMsSsoPayload(): void {
  sessionStorage.removeItem(PORTAL_MS_SSO_STORAGE_KEY)
}
